export default function ($scope, $stateParams, editUser, $state, toaster, userDetails, userRoles) {
    const userId = $stateParams.userId;
    const vm = this;

    vm.allRoles = userRoles.items;
    vm.roles = {};
    vm.rolesError = null;

    for (let count = 0; count < vm.allRoles.length; count++) {
        vm.roles[vm.allRoles[count].value] = false;
    }

    vm.form = null;
    vm.recordNotFetched = true;
    vm.errorsOccurred = false;

    userDetails(userId)
        .then(userData => {
            vm.userData = userData;

            const roles = userData.roles.map(value => value);

            for (let count = 0; count < vm.allRoles.length; count++) {
                const isInRole = roles.indexOf(vm.allRoles[count].roleToSave) > -1;
                vm.roles[vm.allRoles[count].value] = isInRole;
            }

            vm.recordNotFetched = false;
            vm.errorsOccurred = false;
        })
        .catch(() => {
            vm.recordNotFetched = true;
            vm.errorsOccurred = true;
        });
}



// WEBPACK FOOTER //
// ./Client/app/admin/users/controllers/view/viewUserCtrl.js